import { string, object, number } from 'yup';
import periodTypes, { customDateType } from 'maps/period-types';
import supportsOneOf from 'helpers/supportsOneOf';

const periodTypeKeys = [
  ...Object.keys(periodTypes),
  ...Object.keys(customDateType),
];

// This validation schemas is written for the ShortFormVideoTrend component

/**
 * @returns {method} A yup schema to be used for validation
 */
function getSchema(): any {
  const schema = object({
    selectedMetricType: string().required().default('both'),
    selectedInterval: string().required().default('week'),
    contentType: string().required().default('total'),
    platformType: string().required().default('all platforms'),
    customDateRange: object({
      fromDate: number(),
      toDate: number(),
    }),
  });

  if (supportsOneOf()) {
    schema.fields.selectedInterval = schema.fields.selectedInterval.concat(
      string().oneOf(periodTypeKeys)
    );
  }

  return schema;
}

export default getSchema;
